export default __webpack_public_path__ + "static/media/ubuntu.c60de854.svg";